import React from 'react';
import { GridContainer, GridItem } from '../../../visual-components/grid/grid';
import { Spacer } from '../../../visual-components/spacer/spacer';
import { Divider } from '../../../visual-components/divider/divider';

type Props = {
  children: React.ReactNode;
};

export const SectionWrapper: React.FC<Props> = ({ children }) => (
  <>
    <Spacer size="06" />
    <GridContainer>
      <GridItem>
        <Divider />
      </GridItem>
    </GridContainer>
    {children}
  </>
);
